// extracted by mini-css-extract-plugin
module.exports = {"brandColorBase":"#44377b","brandColorSecondary":"#072229"};